import React from 'react';
import SEOHead from '../components/SEOHead';

const HOTEL_LINKS = [
  { name: 'Booking.com', url: 'https://www.booking.com' },
  { name: 'Expedia', url: 'https://www.expedia.com' },
  { name: 'Agoda', url: 'https://www.agoda.com' },
];

const Hotels = () => (
  <>
    <SEOHead
      title="Hotels in World Cup 2026 Host Cities - WorldCup Fan Planner"
      description="Book accommodation in USA, Canada, and Mexico for the 2026 FIFA World Cup. Partner links to major hotel sites."
    />
  <div className="max-w-7xl mx-auto px-4 py-8">
    <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-6">Hotels</h1>
    <p className="text-gray-600 dark:text-gray-400 mb-6">Book hotels in World Cup 2026 host cities.</p>
    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {HOTEL_LINKS.map((h) => (
        <a key={h.name} href={h.url} target="_blank" rel="noopener noreferrer" className="p-4 rounded-lg bg-white dark:bg-gray-800 shadow dark:shadow-gray-900 border dark:border-gray-700 hover:ring-2 hover:ring-amber-500">
          {h.name}
        </a>
      ))}
    </div>
  </div>
  </>
);

export default Hotels;
